// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2cELT","inputWrap":"styles_inputWrap__2w7_2","input":"styles_input__3J84Q"};